import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorTooltipModule } from '../../atoms/error-tooltip/error-tooltip.module';
import { ButtonModule } from '../../forms/button/button.module';
import { SimpleModalModule } from './../simple-modal/simple-modal.module';
import { HelpIconComponent } from './help-icon.component';

@NgModule({
  declarations: [HelpIconComponent],
  imports: [CommonModule, SimpleModalModule, ButtonModule, ErrorTooltipModule],
  exports: [HelpIconComponent]
})
export class HelpIconModule {}
